// Aqui se centralizan los strings de las rutas
export class RouterNames {
    public static Login: string = 'Login';
    public static mainlayout: string = 'mainlayout';
    public static Home: string = 'Home';
    public static cerrar_session:string="cerrar_session";
    public static notificaciones:string="notificaciones";
    public static table:string="table";
    public static tablas:string="tablas";
    public static tablas_test:string="tablas_test";
    public static usuarios:string="usuarios";
    public static usuarioslista:string="usuarioslista";
    public static usuariosformulario:string="usuariosformulario";
    public static FullViewKanban:string="FullViewKanban";
    public static mi_perfil:string="mi_perfil";
    public static administracion:string="administracion";
    public static gruposlista:string="gruposlista";
    public static grupos:string="grupos";
    public static gruposformulario:string="gruposformulario";
    public static lostpwd:string="lostpwd";
    public static confirm_new_password:string="confirm_new_password";
    public static instalacion:string="instalacion";
    public static inventario:string="inventario";
    public static rol:string="rol";
    public static rollista:string="rollista";
    public static rolformulario:string="rolformulario";
    public static plataforma:string="plataforma";
    public static instalacion_plataforma:string="instalacion_plataforma";
    public static tablasformulario:string="tablasformulario";
    public static tablaslista:string="tablaslista";
    public static menu_plataforma:string="menu_plataforma";
    public static menu_plataforma_lista:string="menu_plataforma_lista";
    public static menu_plataforma_formulario:string="menu_plataforma_formulario";
    public static enumeraciones:string="enumeraciones";
    public static enumeracion:string="enumeracion";
    public static viewKanban:string="viewKanban";
    public static kanban:string="kanban";
    public static tbkn:string="tbkn";
    public static viewtbkn:string="viewtbkn";
    public static clientes:string="clientes";
    public static clientesformulario:string="clientesformulario";
    public static createdynamicfromulario:string="CreateDynamicmromulario";
    public static createdynamicmenu:string="createdynamicmenu";
    public static formularios_dynamicos:string="formularios_dynamicos";
    public static formulario_dynamico:string="formulario_dynamico";
    public static formulario_relojes:string="formulario_relojes";
    public static relojes:string="relojes";
    public static lista_relojes:string="lista_relojes";
    public static importacion:string="importacion";
    public static importacionformulario:string="importacionformulario";
    public static dxtable:string="dxtable";
    public static productos:string="productos";
    public static stock:string="stock";
    public static stocklista:string="stocklista";
    public static stockformulario:string="stockformulario";
    public static escanear:string="escanear";
    public static fichaproducto:string="fichaproducto";
    public static producto:string="producto";
    public static escaner:string="escaner";
    public static lector_codigos:string="lector_codigos";
    public static receptor_codigos:string="receptor_codigos";
    public static lector_codigos_sinautentificacion:string="lector_codigos_sinautentificacion";
    public static escaner_sinautentificacion:string="escaner_sinautentificacion";
    public static tienda:string="tienda";
    public static tienda_productos:string="tienda_productos";
    public static tienda_producto:string="tienda_producto";
    public static configuracion_clientes:string="configuracion_clientes";
    public static cajas:string="cajas";
    public static cajasstock:string="cajasstock";
    public static cajasstocklista:string="cajasstocklista";
    public static cajasstockformulario:string="cajasstockformulario";
    public static reservas:string="reservas";
    public static reservaslista:string="reservaslista";
    public static devoluciones:string="devoluciones";
    public static devolucioneslista:string="devolucioneslista";
    public static pdte:string="pdte";
    public static pdtelista:string="pdtelista";
    public static escanearProducto:string="escanearProducto";
    public static amazon:string="amazon";
    public static amazonscraping:string="amazonscraping";
    public static amazonscrapingproductos:string="amazonscrapingproductos";
    public static stockcrear_nuevo:string="stockcrear_nuevo";
    public static escanearfisico:string="escanearfisico";
    public static cajasimagenes:string="cajasimagenes";
    public static stockhistorialventa:string="stockhistorialventa";
    public static Gps:string="Gps";
    public static RutaGps:string="RutaGps";
    public static PlanificadorRutas:string="PlanificadorRutas";
    public static PlanificadorRutasBackend:string="PlanificadorRutasBackend";
    public static PlanificadorRutasManual:string="PlanificadorRutasManual";
    public static EditRuta:string="EditRuta";
    public static importacion_excel:string="importacion_excel";
    public static importacionformulario_excel:string="importacionformulario_excel";
    public static centros:string="centros";
    public static centrosformulario:string="centrosformulario";
    public static importacionprogreso:string="importacionprogreso";
    public static importacionprogresoformulario:string="importacionprogresoformulario";
    public static centros_gruposformulario:string="centros_gruposformulario";
    public static planificaciones:string="planificaciones";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
        //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
    //    public static estados_fisiologicos:string="estados_fisiologicos";
       
}
